function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxTfCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102 108.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.82,97.85v6.66A3.52,3.52,0,0,0,91.35,108h3.11A3.52,3.52,0,0,0,98,104.51V97.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.61,97.85v6.66A3.52,3.52,0,0,0,44.14,108h3.11a3.52,3.52,0,0,0,3.52-3.52V97.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.67,77.1,89.93,55.75a2.62,2.62,0,0,0-2.31-1.37l-37.94.06a2.2,2.2,0,0,0-1.93,1.24C45.46,60,38.2,74.45,36.68,77.47a2.53,2.53,0,0,0-.28,1.18V90.79A2.63,2.63,0,0,0,39,93.42l60.32-.06A2.65,2.65,0,0,0,102,90.72V78.37A2.7,2.7,0,0,0,101.67,77.1Zm-54.2-5.7c1.92-3.81,4.05-8,5-9.84a1.71,1.71,0,0,1,1.5-1l29.56,0a2,2,0,0,1,1.8,1.06l5.35,9.73a1.38,1.38,0,0,1-1.22,2.05H48.7A1.37,1.37,0,0,1,47.47,71.4ZM45.69,86.56a4.84,4.84,0,1,1,4.84-4.84A4.84,4.84,0,0,1,45.69,86.56Zm47.21,0a4.84,4.84,0,1,1,4.84-4.84A4.84,4.84,0,0,1,92.9,86.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.81,28.11a1.83,1.83,0,0,0-1.62-1l-26.81,0A1.58,1.58,0,0,0,8,28.06C6.4,31.12,1.27,41.32.2,43.45a1.89,1.89,0,0,0-.2.84v8.57a1.87,1.87,0,0,0,1.87,1.87l14.4,0c1.42-2.82,4.86-9.66,7.16-14.13H8.69a1,1,0,0,1-.87-1.42c1.36-2.68,2.86-5.64,3.55-6.94a1.21,1.21,0,0,1,1.06-.68l20.88,0a1.44,1.44,0,0,1,1.27.75l2.29,4.16h5.51ZM10,46.46A3.42,3.42,0,1,1,6.57,43,3.42,3.42,0,0,1,10,46.46ZM3,62.56a2.49,2.49,0,0,0,2.49,2.49H7.66a2.49,2.49,0,0,0,2.49-2.49V57.44H3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.72,16.16,72.41,6.51a1.2,1.2,0,0,0-1-.62l-17.16,0a1,1,0,0,0-.87.56c-.26.49-.67,1.28-1.14,2.21h4.67l.14,0,12.52,0a.94.94,0,0,1,.81.48l2.42,4.4a.63.63,0,0,1-.55.93H60.89l3.44,6.26a1.46,1.46,0,0,1,.17.68v2.1l12.17,0a1.19,1.19,0,0,0,1.2-1.19V16.74A1.32,1.32,0,0,0,77.72,16.16Zm-4,4.28a2.19,2.19,0,1,1,2.19-2.19A2.19,2.19,0,0,1,73.75,20.44Zm-2.29,8.12a1.59,1.59,0,0,0,1.59,1.59h1.41a1.59,1.59,0,0,0,1.59-1.59v-3H71.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.17,13.86a1.45,1.45,0,0,0-1.3-.77h-7.4c.8-1.6,2-4,3.15-6.22h-3.4a.5.5,0,0,1-.45-.73c.7-1.37,1.47-2.88,1.82-3.55a.61.61,0,0,1,.54-.35l10.69,0s.07,0,.11,0H62.1l-1-1.77A1,1,0,0,0,60.3,0L46.57,0a.81.81,0,0,0-.7.45c-.82,1.57-3.45,6.79-4,7.88a.91.91,0,0,0-.1.43V13.1l-9.35,0a1.27,1.27,0,0,0-1.09.7c-.88,1.66-3,6-4.63,9.08h4.4a1.59,1.59,0,0,1,.07-.2c1.09-2.15,2.29-4.51,2.84-5.55a1,1,0,0,1,.85-.55l16.71,0a1.14,1.14,0,0,1,1,.61l3,5.5a.78.78,0,0,1-.69,1.15H40l6.21,11.3,14.25,0A1.49,1.49,0,0,0,62,33.62v-7a1.48,1.48,0,0,0-.18-.72Zm-10-5.72a1.75,1.75,0,1,1-1.75,1.75A1.75,1.75,0,0,1,45.13,8.14ZM56.85,31.27a2.74,2.74,0,1,1,2.73-2.73A2.73,2.73,0,0,1,56.85,31.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.76,74.66a3.1,3.1,0,0,1,.33-1.4c1.11-2.21,4.81-9.57,8.13-16.1H29.27a1.23,1.23,0,0,1-1.09-1.78c1.7-3.36,3.58-7.05,4.44-8.68a1.5,1.5,0,0,1,1.32-.85l26.11,0h8l-2.32-4.23a2.32,2.32,0,0,0-2-1.21l-33.51,0a2,2,0,0,0-1.7,1.09c-2,3.83-8.44,16.58-9.77,19.25a2.22,2.22,0,0,0-.25,1V72.51a2.33,2.33,0,0,0,2.33,2.33l11,0Zm-5.15-5.89a4.27,4.27,0,1,1,4.28-4.27A4.27,4.27,0,0,1,26.61,68.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.13,78.47v6.16a3.11,3.11,0,0,0,3.11,3.11H28a3.11,3.11,0,0,0,3.11-3.11V78.47Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxTfCurrent);
export default __webpack_public_path__ + "static/media/tx_TFCurrent.e8e580f6f2d787a9d838ef92166b5d16.svg";
export { ForwardRef as ReactComponent };